import Vue from 'vue'
import DialogBox from '@/components/DialogBox.vue'
import { i18nn } from '../main'

const DialogConstructor = Vue.extend(DialogBox)


const DialogPlugin = {
  install(Vue) {
    const instance = new DialogConstructor({
      // TOTO JE MAGIA: parent = root instance
      i18nn,
      parent: Vue.prototype.$root || null
    })

    instance.$mount()
    document.body.appendChild(instance.$el)



    Vue.prototype.$dialog = {
      alert(data) {
        return instance.open({ ...data, leftButton: data.leftButton || i18nn.t('cancel'), rightButton: data.rightButton || i18nn.t('ok') }, 'alert')
      },
      confirm(data) {
        return instance.open({ ...data, leftButton: data.leftButton || i18nn.t('cancel'), rightButton: data.rightButton || i18nn.t('ok') }, 'confirm')
      },
      prompt(data) {
        return instance.open({ ...data, leftButton: data.leftButton || i18nn.t('cancel'), rightButton: data.rightButton || i18nn.t('ok') }, 'prompt')
      }
    }
  }
}

export default DialogPlugin
